import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { markNotificationRead } from "../redux/notificationsSlice";
import "./NotificationPanel.css";

// Bell dropdown (home screen, anchored under the top bar's bell): a preview list of admin
// blasts — bold one-line subject, smaller body clamped to 3 lines, orange dot while unread —
// plus the full-message dialog. ONLY opening a message in full marks it read; hovering the
// bell, opening this panel or scrolling the list never does.

const formatWhen = (createdAt) => {
    if (!createdAt) return "";
    const d = new Date(createdAt);
    return isNaN(d.getTime()) ? "" : d.toLocaleString();
};

const NotificationPanel = ({ onClose }) => {
    const dispatch = useDispatch();
    const items = useSelector((state) => state.notifications.items);
    const [openItem, setOpenItem] = useState(null);

    // The one place a notification becomes "read" — opening it in full.
    const openMessage = (item) => {
        setOpenItem(item);
        dispatch(markNotificationRead(item.id));
    };

    return (
        <>
            {/* Transparent click-catcher: clicking anywhere off the panel closes it. */}
            <div className="notif-click-catcher" onClick={onClose} />

            <div className="notif-panel" role="dialog" aria-label="Notifications">
                <div className="notif-panel-header">
                    <span className="notif-panel-title">Notifications</span>
                    <button
                        type="button"
                        className="notif-panel-close"
                        onClick={onClose}
                        aria-label="Close notifications"
                    >
                        &times;
                    </button>
                </div>
                <div className="notif-list">
                    {items.length === 0 ? (
                        <div className="notif-empty">No notifications yet.</div>
                    ) : (
                        items.map((item) => (
                            <button
                                type="button"
                                key={item.id}
                                className="notif-row"
                                onClick={() => openMessage(item)}
                            >
                                <span
                                    className={`notif-unread-dot ${item.read ? "notif-unread-dot-read" : ""}`}
                                    aria-hidden="true"
                                />
                                <span className="notif-row-content">
                                    <span className="notif-subject">{item.subject}</span>
                                    <span className="notif-preview-body">{item.body}</span>
                                    <span className="notif-when">{formatWhen(item.createdAt)}</span>
                                </span>
                            </button>
                        ))
                    )}
                </div>
            </div>

            {/* Full-message dialog (same overlay vocabulary as the app's other modals). */}
            {openItem && (
                <div className="notif-message-overlay" onClick={() => setOpenItem(null)}>
                    <div
                        className="notif-message-dialog"
                        onClick={(e) => e.stopPropagation()}
                        role="dialog"
                        aria-modal="true"
                    >
                        <h3 className="notif-message-subject">{openItem.subject}</h3>
                        <div className="notif-message-when">{formatWhen(openItem.createdAt)}</div>
                        <div className="notif-message-body">{openItem.body}</div>
                        <button
                            type="button"
                            className="notif-message-close"
                            onClick={() => setOpenItem(null)}
                        >
                            Close
                        </button>
                    </div>
                </div>
            )}
        </>
    );
};

export default NotificationPanel;
